import { forwardRef } from 'react';
import { v4 as uuid } from 'uuid';

import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    const id = uuid();

    return (
        <SvgIcon ref={ref} {...props}>
            <g clipPath={`url(#${id})`}>
                <path d='M21.6 2.4V18C15.312 18 17.304 18 14.472 18C13.596 19.632 13.992 18.948 12.528 21.36C12.396 21.552 12.216 21.636 12.084 21.636C11.952 21.636 11.772 21.612 11.652 21.42C10.98 20.448 11.364 21.096 9.72001 18C6.79201 18 8.904 18 2.388 18V2.4H21.6ZM24 0H0V20.4H8.46C9.42 22.2 10.068 24 12.096 24C14.232 24 14.58 22.536 15.744 20.4H24V0Z' />
            </g>
            <defs>
                <clipPath id={id}>
                    <rect width='24' height='24' />
                </clipPath>
            </defs>
        </SvgIcon>
    );
});
